import { Box } from '@mui/material'
import ShowChartIcon from '@mui/icons-material/ShowChart'
import InstagramIcon from '@mui/icons-material/Instagram'

type Props = {
  sizePx?: number
}

export const InstagramGrowthIcon = ({ sizePx = 20 }: Props) => {
  return (
    <Box
      sx={{
        position: 'relative',
        display: 'inline-block',
        width: sizePx,
        height: sizePx,
      }}
    >
      <ShowChartIcon sx={{ fontSize: sizePx, color: '#5686E1' }} />
      <InstagramIcon
        sx={{
          position: 'absolute',
          fontSize: sizePx / 2,
          color: '#EA3EF7',
          top: '60%',
          left: '60%',
        }}
      />
    </Box>
  )
}
